import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, toRefs, computed } from 'vue'
import { clone } from 'ramda'

export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleChecker',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  value: {
    type: Boolean,
    default: false,
  },
  label: {
    default: '',
  },
},
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

// const { modelValue } = toRefs(props)
const emit = __emit
const val = ref(false)

function setValue(val) {
  emit("update:modelValue", val)
}

// const val = computed({
//   get: () => props.modelValue,
//   set: (newVal) => emit('update:modelValue', newVal),
// })

watch(() => props.modelValue, () => {
  val.value = clone(props.modelValue)
  setValue(val.value)
}, { deep: true, immediate: true })


const __returned__ = { props, emit, val, setValue, ref, watch, toRefs, computed, get clone() { return clone } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})